export default function ChartTooltip({ active, payload, label, formatter }) {
  if (!active || !payload || !payload.length) return null;

  return (
    <div className="chart-tooltip">
      {label !== undefined && <div className="chart-tooltip__label">{label}</div>}
      {payload.map((p, i) => {
        const val = p.value;
        const formatted =
          val !== undefined && val !== null && !Number.isNaN(val)
            ? formatter
              ? formatter(val, p)
              : typeof val === "number"
              ? val.toLocaleString("en-IN")
              : String(val)
            : "0";

        return (
          <div key={i} className="chart-tooltip__value">
            {formatted}
          </div>
        );
      })}
    </div>
  );
}
